'use client';

import React, { useState } from 'react';
import {
  GetFishingWater_fishingWater_country,
  GetFishingWater_fishingWater_region,
  GetPlaceTopSpecies_entry_topSpeciesSummary,
  GetPlaceTopWaters_entry_edges_node,
} from '../../../../interfaces/graphql';
import { useAnalytics } from '../../../../contexts/AnalyticsContext/AnalyticsContext';
import { trackEvent } from '../../../../helpers/analytics/trackEvent';
import { AppDownloadModal } from '../../../../components/AppDownloadModal/AppDownloadModal';
import { getFAQData } from './helpers/getFAQData';
import { FishingReport } from '../../../../components/FishingReportsGrid/components/FishingReportCard';
import { FAQ } from '../../../../components/FAQ/FAQ';

interface IProps {
  country: GetFishingWater_fishingWater_country | null;
  id?: string;
  region: GetFishingWater_fishingWater_region | null;
  recentCatchPostList: FishingReport[];
  placeId: string;
  placeName: string;
  placeSlug: string;
  topWaters: GetPlaceTopWaters_entry_edges_node[];
  topSpeciesSummary?: GetPlaceTopSpecies_entry_topSpeciesSummary;
}

export const FAQSection = ({
  country,
  id = 'FAQSection',
  region,
  recentCatchPostList,
  placeName,
  placeId,
  placeSlug,
  topWaters,
  topSpeciesSummary,
}: IProps) => {
  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);
  const { currentPage } = useAnalytics();

  const handleCTAClick = (): void => {
    void trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        source: 'FAQSection',
        source_id: placeId,
        type: 'downloadModal',
        page: currentPage,
      },
    });
    setIsAppDownloadModalOpen(true);
  };

  const faqData = getFAQData({
    country,
    placeName,
    placeSlug,
    handleCTAClick,
    region,
    recentCatchPostList,
    topWaters,
    topSpeciesSummary,
  });

  return (
    <FAQ
      className="mb-fw scroll-mt-(--navigation-scrolltop-offset-mobile) sm:scroll-mt-(--navigation-scrolltop-offset)"
      faqData={faqData}
      headingVariant="sm"
      id={id}
      showFAQMetaData
      title={`FAQ about ${placeName} fishing`}
    >
      <AppDownloadModal
        appDownloadSource="FAQSection"
        appDownloadSourceId={placeId}
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
      />
    </FAQ>
  );
};
